module.exports = __webpack_public_path__ + "fonts/iconfont.e8cebb2.ttf";